import {
  Avatar,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./style.css";
import LinkIcon from "@material-ui/icons/Link";
import { Close } from "@material-ui/icons";
export const CollegeList = () => {
  const [collegeData, setCollegeData] = useState([]);
  const [allCollegeData, setAllCollegeData] = useState([]);
  const [comCollege, setComCollege] = useState([]);
  const [govtCollege, setGovtCollege] = useState([]);
  const [pvtCollege, setPvtCollege] = useState([]);
  const sortDataByName = (a, b) => {
    const college_name_a = a.college_name.toUpperCase();
    const college_name_b = b.college_name.toUpperCase();
    if (college_name_a > college_name_b) {
      return 1;
    } else if (college_name_a < college_name_b) {
      return -1;
    }
    return 0;
  };
  const displayDataByType = (type) => {
    if (type === "all") {
      setCollegeData(allCollegeData);
    } else if (type === "Government") {
      setCollegeData(govtCollege);
    } else if (type === "Private") {
      setCollegeData(pvtCollege);
    } else {
      setCollegeData(comCollege);
    }
  };
  function fetchData() {
    fetch("/data.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const colleges = data.colleges.sort(sortDataByName);
        setCollegeData(colleges);
        setAllCollegeData(colleges);
        let newArray1 = [...colleges];
        newArray1 = newArray1.filter((item) => item.type === "Government");
        setGovtCollege(newArray1);
        let newArray2 = [...colleges];
        newArray2 = newArray2.filter((item) => item.type === "Private");
        setPvtCollege(newArray2);
        let newArray3 = [...colleges];
        newArray3 = newArray3.filter((item) => item.type === "Community");
        setComCollege(newArray3);
      })
      .catch((e) => console.log("Error reading data", e.message));
  }
  useEffect(() => {
    fetchData();
    return () => {
      // eslint-disable-next-line
    };
  }, []);
  const handleChange = (e) => {
    displayDataByType(e.target.value);
  };

  return (
    <div className="container college-list-section grid my-5">
      <div class="college-list-container">
        <h1 className="section-title text-center fw-500">College List</h1>
        <div className="divider"></div>
        <div className="flex ai-c">
          <div>
            <span className="fw-500">Filter by:</span>
            <span className="fw-500 ml-3 text-black-accent">Type</span>
            <select className="ml-1" name="sortby" onChange={handleChange}>
              <option value="all">All</option>
              <option value="Government">Government</option>
              <option value="Private">Private</option>
              <option value="Community">Community</option>
            </select>
            <span className="fw-500 ml-3 text-black-accent">
              No.of Colleges:{" "}
            </span>
            <span className="ml-1 text-sans">{collegeData.length}</span>
          </div>
        </div>
        {collegeData.length === 0 ? (
          <CircularProgress className="m-5 p-5" />
        ) : (
          <ul className="college-list">
            {collegeData.sort().map((college, index) => (
              <li className="college-list-item my-1" key={index}>
                <div className="flex ai-c py-1">
                  <div className="college-list-image-container text-center">
                    {typeof college.logo === null ||
                    typeof college.logo === "undefined" ? (
                      <Avatar>{college.college_name.trim()[0]}</Avatar>
                    ) : (
                      <img
                        className="college-list-image"
                        src={college.logo}
                        alt={college.college_name}
                      />
                    )}
                  </div>
                  <h2 className="ml-2 fw-500 college-title">
                    {college.college_name}
                  </h2>
                </div>
                <div class="overlay-link-container flex jc-c ai-c">
                  {college.website !== "-" ? (
                    <span>
                      <Link
                        target="_blank"
                        to={`/college-website/${college.website}`}
                        className="link text-blue"
                      >
                        <Tooltip title="Visit Site">
                          <LinkIcon />
                        </Tooltip>
                      </Link>
                    </span>
                  ) : (
                    <span className="flex ai-c">
                      <Close />
                      <span className="ml-1 text-white">No site found</span>
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div></div>
    </div>
  );
};
